import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Planica up close",
  "description": "",
  "published": "2012-03-17T00:00:00.000Z",
  "redirect_from": ["/blog/planica-up-close/swizec/3996"],
  "categories": "IPhone, Planica, Robert Kranjec, Skiing, Sports, Television, Travel + Events, Winter Sports",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Wake up! Wake up, we're gonna be late!`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/fa00e838704a11e18bb812313804a181_72.jpg",
        "alt": "Planica",
        "title": "Planica"
      }}></img></p>
    <p>{`5am.`}</p>
    <p>{`Took my sister to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.4983333333,13.7391666667&spn=0.1,0.1&q=46.4983333333,13.7391666667%20(Planica)&t=h",
        "title": "Planica"
      }}>{`Planica`}</a>{` to watch a bunch of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Flying_squirrel",
        "title": "Flying squirrel"
      }}>{`flying squirrel`}</a>{` men throw themselves off a big hill with long sticks attached to their feet to see who can go the farthest. All the while suffering a bunch of loud drunkish people.`}</p>
    <p>{`At least that's what I thought ... but all in all it was actually pretty damn awesome!`}</p>
    <p>{`The two free tickets didn't just get us in the event place, after some careful maneuvering by The Ticket Guy we also got into the VIP section, right under the landing spot, with a good view of the whole flight.`}</p>
    <p>{`Then the VIP section turned into the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Very_Important_Person",
        "title": "Very Important Person"
      }}>{`VIP seats`}</a>{`, the ones closest to all the action.`}</p>
    <p>{`Then it became a trip up the hill to see everything `}<em parentName="p">{`very`}</em>{` up close.`}</p>
    <p>{`Even the judge's house thingy.`}</p>
    <p>{`I will never forget the eery calm of standing right next to the slope and having a guy `}<em parentName="p">{`fall`}</em>{` past you, into nothing, seemingly laying on air. Subtle whoosh sound. Amazing.`}</p>
    <p>{`And the speed on the take off ramp! Wow! TV doesn't do it justice `}<em parentName="p">{`at all`}</em>{`. Yeah, sure, he's doing 104km/h, so what? But when you're standing 10 meters away ... damn. Those guys are wearing underpants with a lot more room than mine have ...`}</p>
    <p>{`Seeing `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Robert_Kranjec",
        "title": "Robert Kranjec"
      }}>{`Robert Kranjec`}</a>{` jump a 231m was ... impressive. The landing looks much harder in real life than it does on the telly.`}</p>
    <p>{`Alas, the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/IPhone",
        "title": "IPhone"
      }}>{`iPhone`}</a>{` camera was too slow to catch anyone in the air.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/photo-3-1024x764.jpg",
        "alt": "Looking up from down below",
        "title": "Looking up from down below"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/photo-1-1024x764.jpg",
        "alt": "A bad crowd shot",
        "title": "A bad crowd shot"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/photo-764x1024.jpg",
        "alt": "There was a guy in a full deer suit",
        "title": "There was a guy in a full deer suit"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/photo-2-1024x764.jpg",
        "alt": "Plenty of balloons behind the VIP area",
        "title": "Plenty of balloons behind the VIP area"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/photo-5-764x1024.jpg",
        "alt": "Ski lifts are weird without snow",
        "title": "Ski lifts are weird without snow"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/photo-4-764x1024.jpg",
        "alt": "Planica's baby sibling",
        "title": "Planica's baby sibling"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/photo-6-764x1024.jpg",
        "alt": "The crowd below",
        "title": "The crowd below"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/photo-8-764x1024.jpg",
        "alt": "Whoosh, gone",
        "title": "Whoosh, gone"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/photo-7-764x1024.jpg",
        "alt": "Best seats?",
        "title": "Best seats?"
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=08a8cb04-5478-47d3-bd8a-9f93f6dca18d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      